import React, { useState } from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
//
//
const ToggleSwitcher: React.FC<{
  defaultValue?: boolean
  onChange?: (value: boolean) => void
  activeRedBackground?: boolean
}> = ({ defaultValue, onChange, activeRedBackground = false }) => {
  //
  const [value, setValue] = useState(defaultValue || false)

  const handleToggle = () => {
    const newValue = !value
    setValue(newValue)
    //
    if (onChange) {
      onChange?.(newValue)
    }
  }
  //
  return (
    <Label onChange={handleToggle} $checked={value} $activeRedBackground={activeRedBackground}>
      <input type="checkbox" onChange={() => {}} checked={defaultValue} />
      <span></span>
    </Label>
  )
}
//
const Label = styled.label<{ $checked: boolean; $activeRedBackground: boolean }>`
  user-select: none;
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;

  /*  */
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /*  */
  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    border-radius: 30px;
    background-color: ${({ $checked, $activeRedBackground }) =>
      $checked === false && $activeRedBackground === true
        ? `${Colors.primaryRed}`
        : $checked === true
        ? `${Colors.primaryRed}`
        : `${Colors.secondaryGrey}`};

    &::before {
      position: absolute;
      content: '';
      height: 14px;
      width: 14px;
      border-radius: 50%;
      background-color: ${Colors.white};
      left: 2px;
      bottom: 2px;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      transform: ${({ $checked }) => ($checked === true ? `translateX(14px)` : `unset`)};
    }
  }
`
//
export default ToggleSwitcher
